import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getPatchPolicyDetails = createAsyncThunk('patchPolicySlice/getPatchPolicyDetails', async (id) => {
    try {
        let response = await axios.get('/patch-policy/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createPatchPolicy = createAsyncThunk('patchPolicySlice/createPatchPolicy', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/patch-policy', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Patch Policy created successfully.');

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updatePatchPolicy = createAsyncThunk('patchPolicySlice/updatePatchPolicy', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/patch-policy/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Patch Policy updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deletePatchPolicy = createAsyncThunk('patchPolicySlice/deletePatchPolicy', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/patch-policy/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Patch Policy deleted successfully');
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const patchPolicySlice = createSlice({
    name: 'patchPolicySlice',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getPatchPolicyDetails.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
    }
});

export default patchPolicySlice.reducer;
